import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HeaderAlt } from './components/HeaderAlt';
import { FooterAlt } from './components/FooterAlt';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { SinglePage } from './pages/SinglePage';
import { HomeAlt } from './pages/HomeAlt';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Catalogs } from './pages/Catalogs';
import ScrollToTop from './components/ScrollToTop';
import { PageTransition } from './components/PageTransition';
import { SeoManager } from './components/SeoManager';
import './App.css';

const routerBasename = process.env.PUBLIC_URL || '/';

function AppContent() {
  const location = useLocation();
  const isSinglePage = location.pathname === '/single';

  return (
    <>
      <SeoManager />
      <ScrollToTop />
      {!isSinglePage && <HeaderAlt />}
      <PageTransition>
        <Routes location={location}>
          <Route path="/" element={<HomeAlt />} />
          <Route path="/projetos" element={<Projects />} />
          <Route path="/projetos/:id" element={<ProjectDetail />} />
          <Route path="/catalogos" element={<Catalogs />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contactos" element={<Contact />} />
          <Route path="/single" element={<SinglePage />} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/privacidade" element={<Privacy />} />
        </Routes>
      </PageTransition>
      {!isSinglePage && <FooterAlt />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={routerBasename}>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
